import axios from 'axios'

export default {
    store: async (data) => {
        try {
            const response = await axios.post('enrollments/store', data);

            // Con interceptor global, axios ya devuelve response.data
            if (response && response.type !== undefined) {
                return response;
            }

            return {
                type: "success",
                data: response,
                status: 200
            };
        } 
        catch (error) {
            console.error("Error en enrollments.store:", error);
            
            // Manejar diferentes tipos de errores
            if (error.response) {
                // El servidor respondió con un status code fuera del rango 2xx
                console.error("Error response:", error.response.data);
                return {
                    type: "error",
                    message: (error.response.data && error.response.data.message) ? error.response.data.message : "Error del servidor. Por favor, intenta nuevamente.",
                    status: error.response.status
                };
            } 
            else if (error.request) {
                // La solicitud se hizo pero no se recibió respuesta
                console.error("No response received:", error.request);
                return {
                    type: "error",
                    message: "No se recibió respuesta del servidor. Verifica tu conexión a internet.",
                    status: null
                };
            } 
            else {
                // Error en la configuración de la solicitud
                console.error("Request error:", error.message);
                return {
                    type: "error",
                    message: error.message || "Error al procesar la solicitud.",
                    status: null
                };
            }
        }
    },
    getCustomer: () => axios.get('customers/me'),
    getEnrollments: () => axios.get('enrollments/me'),
    getEnrollmentPayments: (enrollment_id) => axios.get('enrollments/'+enrollment_id+"/payments"),
    uploadPayment: (data, enrollment_id) => axios.post('enrollments/'+enrollment_id+'/store-payment', data),
}